import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrReorder202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_reorder_202604",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 83236,
  clicks: 1212,
  adsSpendDollars: 7999,
  budgetDollars: 9000,
  salesDollars: 60091,
  bestEstimateRoas: 7.51,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.89,
  reorderConversions: 207,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
